import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'


export default {
    taskName: taskName.FIT_GUIDE,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.SENT_EMAIL_WIDGET,
        },
        {
            component: processUI.INVOICE_LIST_WIDGET,
        },
        {
            component: processUI.PAYMENT_LIST_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
        {
            component: processUI.TECHNICAL_LOG_CONTAINER,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-treatment/fit-guide.js